import React, { FC } from 'react';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import { getFormattedDate } from 'components/availability-wrapper/utils';
import { DATE_FNS_LOCALES } from 'constants/languageConstants';
import { useTranslations } from 'next-intl';
import { DeliveryAvailability } from 'services/dealerPriceAvailability/types';
import CutoffTime from '../cut-off-time/cut-off-time';
import { cutoffTimesType } from 'components/availability-wrapper/types';
import styles from '../store-availability.module.scss';
export interface EstimatedDeliveryDateProps {
  deliveryAvailability: DeliveryAvailability;
  locale: string;
  cutoffTimesData: cutoffTimesType;
}
const EstimatedDeliveryDate: FC<EstimatedDeliveryDateProps> = ({
  deliveryAvailability,
  locale,
  cutoffTimesData
}) => {
  const t = useTranslations();
  const { byDate } = deliveryAvailability;

  return (
    <>
      {byDate?.map(
        (item) =>
          item.date && (
            <>
              <p className="cat-u-margin-bottom-sm fw-bold">
                {replaceTokensInString(
                  t('AVAIL_STANDARD_DELIVERY', {
                    0: item.quantity,
                    1: getFormattedDate(
                      item.date,
                      {
                        locale: DATE_FNS_LOCALES[locale]
                      },
                      'MMM'
                    ),
                    2: getFormattedDate(item.date, '', 'dd')
                  })
                )}
              </p>

              <p
                className={`cat-u-margin-bottom-none cat-u-margin-top-sm fw-bold ${styles['cutoff-time-text']}`}
              >
                <CutoffTime
                  cutoffTime={cutoffTimesData?.delivery}
                  timezone={cutoffTimesData?.timezone}
                />
              </p>
            </>
          )
      )}
    </>
  );
};
export default EstimatedDeliveryDate;
